import { createI18n } from 'vue-i18n'

// zh-CN
import zhCN_common from './locale/zh-CN/common.json'
import zhCN_nav from './locale/zh-CN/nav.json'
import zhCN_footer from './locale/zh-CN/footer.json'
import zhCN_auth from './locale/zh-CN/auth.json'
import zhCN_member from './locale/zh-CN/member.json'
import zhCN_admin from './locale/zh-CN/admin.json'
import zhCN_product from './locale/zh-CN/product.json'
import zhCN_techservice from './locale/zh-CN/techservice.json'
import zhCN_techpages from './locale/zh-CN/techpages.json'
import zhCN_pages from './locale/zh-CN/pages.json'
import zhCN_seo from './locale/zh-CN/seo.json'
import zhCN_servicepages from './locale/zh-CN/servicepages.json'
import zhCN_hydrogels from './locale/zh-CN/hydrogels.json'
import zhCN_enzymes from './locale/zh-CN/enzymes.json'
import zhCN_search from './locale/zh-CN/search.json'

// en-US
import enUS_common from './locale/en-US/common.json'
import enUS_nav from './locale/en-US/nav.json'
import enUS_footer from './locale/en-US/footer.json'
import enUS_auth from './locale/en-US/auth.json'
import enUS_member from './locale/en-US/member.json'
import enUS_admin from './locale/en-US/admin.json'
import enUS_product from './locale/en-US/product.json'
import enUS_techservice from './locale/en-US/techservice.json'
import enUS_techpages from './locale/en-US/techpages.json'
import enUS_pages from './locale/en-US/pages.json'
import enUS_seo from './locale/en-US/seo.json'
import enUS_servicepages from './locale/en-US/servicepages.json'
import enUS_hydrogels from './locale/en-US/hydrogels.json'
import enUS_enzymes from './locale/en-US/enzymes.json'
import enUS_search from './locale/en-US/search.json'

function mergeMessages(...modules) {
  return Object.assign({}, ...modules)
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': mergeMessages(
      zhCN_common, zhCN_nav, zhCN_footer, zhCN_auth,
      zhCN_member, zhCN_admin, zhCN_product,
      zhCN_techservice, zhCN_techpages, zhCN_pages, zhCN_seo
      , zhCN_servicepages
      , zhCN_hydrogels
      , zhCN_enzymes
      , zhCN_search
    ),
    'en-US': mergeMessages(
      enUS_common, enUS_nav, enUS_footer, enUS_auth,
      enUS_member, enUS_admin, enUS_product,
      enUS_techservice, enUS_techpages, enUS_pages, enUS_seo
      , enUS_servicepages
      , enUS_hydrogels
      , enUS_enzymes
      , enUS_search
    ),
  },
})

export default i18n
